import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as style from "./styles.module.scss";
import { postBig5PersonalityTest } from "../../redux/actions/psychometricTestsActions";
import history from "../../history";
import ProgressBar from "../MyTests/ProgressBar";

const Big5Personality = ({ appData, postBig5PersonalityTestFunc }) => {
  const name = `${appData.firstName} ${appData.lastName}`;
  const questions = [
    {
      question: "I am the life of the party.",
      keyed: "+",
      factor: "1",
    },
    {
      question: "I feel little concern for others.",
      keyed: "-",
      factor: "2",
    },
    {
      question: "I am always prepared.",
      keyed: "+",
      factor: "3",
    },
    {
      question: "I get stressed out easily.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I have a rich vocabulary.",
      keyed: "+",
      factor: "5",
    },
    {
      question: "I don't talk a lot.",
      keyed: "-",
      factor: "1",
    },
    {
      question: "I am interested in people.",
      keyed: "+",
      factor: "2",
    },
    {
      question: "I leave my belongings around.",
      keyed: "-",
      factor: "3",
    },
    {
      question: "I am relaxed most of the time.",
      keyed: "+",
      factor: "4",
    },
    {
      question: "I have difficulty understanding abstract ideas.",
      keyed: "-",
      factor: "5",
    },
    {
      question: "I feel comfortable around people.",
      keyed: "+",
      factor: "1",
    },
    {
      question: "I insult people.",
      keyed: "-",
      factor: "2",
    },
    {
      question: "I pay attention to details.",
      keyed: "+",
      factor: "3",
    },
    {
      question: "I worry about things.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I have a vivid imagination.",
      keyed: "+",
      factor: "5",
    },
    {
      question: "I keep in the background.",
      keyed: "-",
      factor: "1",
    },
    {
      question: "I sympathize with others' feelings.",
      keyed: "+",
      factor: "2",
    },
    {
      question: "I make a mess of things.",
      keyed: "-",
      factor: "3",
    },
    {
      question: "I seldom feel blue.",
      keyed: "+",
      factor: "4",
    },
    {
      question: "I am not interested in abstract ideas.",
      keyed: "-",
      factor: "5",
    },
    {
      question: "I start conversations.",
      keyed: "+",
      factor: "1",
    },
    {
      question: "I am not interested in other people's problems.",
      keyed: "-",
      factor: "2",
    },
    {
      question: "I get chores done right away.",
      keyed: "+",
      factor: "3",
    },
    {
      question: "I am easily disturbed.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I have excellent ideas.",
      keyed: "+",
      factor: "5",
    },
    {
      question: "I have little to say.",
      keyed: "-",
      factor: "1",
    },
    {
      question: "I have a soft heart.",
      keyed: "+",
      factor: "2",
    },
    {
      question: "I often forget to put things back in their proper place.",
      keyed: "-",
      factor: "3",
    },
    {
      question: "I get upset easily.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I do not have good imagination.",
      keyed: "-",
      factor: "5",
    },
    {
      question: "I talk to a lot of different people at parties.",
      keyed: "+",
      factor: "1",
    },
    {
      question: "I am not really interested in others.",
      keyed: "-",
      factor: "2",
    },
    {
      question: "I like order.",
      keyed: "+",
      factor: "3",
    },
    {
      question: "I change my mood a lot.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I am quick to understand things.",
      keyed: "+",
      factor: "5",
    },
    {
      question: "I don't like to draw attention to myself.",
      keyed: "-",
      factor: "1",
    },
    {
      question: "I take time out for others.",
      keyed: "+",
      factor: "2",
    },
    {
      question: "I shirk my duties.",
      keyed: "-",
      factor: "3",
    },
    {
      question: "I have frequent mood swings.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I use difficult words.",
      keyed: "+",
      factor: "5",
    },
    {
      question: "I don't mind being the center of attention.",
      keyed: "+",
      factor: "1",
    },
    {
      question: "I feel others' emotions.",
      keyed: "+",
      factor: "2",
    },
    {
      question: "I follow a schedule.",
      keyed: "+",
      factor: "3",
    },
    {
      question: "I get irritated easily.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I spend time reflecting on things.",
      keyed: "+",
      factor: "5",
    },
    {
      question: "I am quiet around strangers.",
      keyed: "-",
      factor: "1",
    },
    {
      question: "I make people feel at ease.",
      keyed: "+",
      factor: "2",
    },
    {
      question: "I am exacting in my work.",
      keyed: "+",
      factor: "3",
    },
    {
      question: "I often feel blue.",
      keyed: "-",
      factor: "4",
    },
    {
      question: "I am full of ideas.",
      keyed: "+",
      factor: "5",
    },
  ];
  const positiveKeyedScale = {
    "Very Inaccurate": 1,
    "Moderately Inaccurate": 2,
    "Neither Inaccurate nor Accurate": 3,
    "Moderately Accurate": 4,
    "Very Accurate": 5,
  };
  const negativeKeyedScale = {
    "Very Accurate": 1,
    "Moderately Accurate": 2,
    "Neither Inaccurate nor Accurate": 3,
    "Moderately Inaccurate": 4,
    "Very Inaccurate": 5,
  };
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswer] = useState([{}]);
  const [chosen, setChosen] = useState("");
  const [progress, setProgress] = useState(0);
  const progressCalculation = Math.round(
    (currentQuestion / questions.length) * 100
  );
  const updateProgress = () => {
    setProgress(progressCalculation);
  };
  const nextQuestion = () => {
    const next = answers[currentQuestion + 1];
    setCurrentQuestion(currentQuestion + 1);
    if (questions[currentQuestion + 1].keyed === "+") {
      setChosen(Object.keys(positiveKeyedScale)[next - 1] || "");
    } else {
      setChosen(Object.keys(negativeKeyedScale)[next - 1] || "");
    }
    updateProgress();
  };
  const previousQuestion = () => {
    const previous = answers[currentQuestion - 1];
    setCurrentQuestion(currentQuestion - 1);
    if (questions[currentQuestion - 1].keyed === "+") {
      setChosen(Object.keys(positiveKeyedScale)[previous - 1] || "");
    } else {
      setChosen(Object.keys(negativeKeyedScale)[previous - 1] || "");
    }
    updateProgress();
  };
  const storeAnswer = (questionNumber, chosenAnswer) => {
    setChosen(chosenAnswer);
    setAnswer({
      ...answers,
      [questionNumber - 1]:
        questions[questionNumber - 1].keyed === "+"
          ? positiveKeyedScale[chosenAnswer]
          : negativeKeyedScale[chosenAnswer],
    });
  };
  const loadChosen = () => {
    const answerScale = answers[currentQuestion - 1];
    if (questions[currentQuestion - 1].keyed === "+") {
      setChosen(Object.keys(positiveKeyedScale)[answerScale - 1]);
    } else {
      setChosen(Object.keys(negativeKeyedScale)[answerScale - 1]);
    }
  };
  const submitTest = () => {
    postBig5PersonalityTestFunc(answers, name);
    history.push("/profile/MyTests/results", {
      testName: "big5Personality",
      pdfName: "Big_5_Personality_Test_Feedback_Fields.pdf",
    });
  };
  const handleOptionButton = (e) => {
    storeAnswer(currentQuestion + 1, e.target.value);
    if (currentQuestion !== questions.length - 1) {
      setTimeout(() => {
        nextQuestion();
      }, 800);
      setProgress(
        Math.round(((currentQuestion + 1) / (questions.length - 1)) * 100)
      );
    }
  };
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div style={{ padding: "5%" }} className="col-sm-9 col-lg-8">
        <div className={style.mainSection}>
          <h2>Big Five Personality Test</h2>
          {ProgressBar(progressCalculation)}
        </div>
        <div>
          <section className="section-body p-1">
            <p className="mb-2">Please select one answer for each question.</p>
            <article>
              <div className={style.mainContainer}>
                <h4 className={style.legendContainer}>
                  <div className={style.question}>
                    Question {currentQuestion + 1} / {questions.length}
                  </div>
                  <div>{questions[currentQuestion].question}</div>
                </h4>
                <div className={style.optionsContainer}>
                  {Object.keys(positiveKeyedScale).map((key, i) => {
                    return (
                      <label
                        key={i}
                        onClick={(event) => handleOptionButton(event)}
                        className={style.optionChoice}
                      >
                         {" "}
                        <input
                          style={{ marginRight: "5px" }}
                          checked={chosen === key}
                          type="radio"
                          id="html"
                          value={key}
                        />
                        {key}
                      </label>
                    );
                  })}
                </div>
              </div>
            </article>
            <div className={style.testButtons}>
              {questions[currentQuestion] === questions[0] ? (
                <button
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                  onClick={() => history.push("/profile/MyTests")}
                >
                  Cancel
                </button>
              ) : (
                <button
                  onClick={() => {
                    loadChosen();
                    previousQuestion();
                  }}
                  style={{ minWidth: "fit-content" }}
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                >
                  Change previous answer
                </button>
              )}
              {currentQuestion === questions.length - 1 && (
                <button
                  disabled={!chosen || chosen === ""}
                  onClick={submitTest}
                  id="btnBasicInfoEditSubmit"
                  className="btn btn-primary col-12 col-sm-3 col-lg-2 my-2"
                >
                  Finish
                </button>
              )}
            </div>
            <div className="d-flex justify-content-end">
              <Link
                to="/profile/MyTests"
                className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
              >
                My Tests
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const mapDispatchToProps = {
  postBig5PersonalityTestFunc: postBig5PersonalityTest,
};
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(Big5Personality);
